module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if( is_bye ) { 
__p+='\n	<div class="column column-1 uppercase">\n		'+
((__t=( round_id ))==null?'':_.escape(__t))+
'\n	</div>\n	<div class="column column-2"></div>\n	<div class="column column-3"></div>\n	<div class="column column-4"></div>\n	<div class="column column-5"></div>\n	<div class="column column-6"></div>\n	<div class="column column-7"><strong>Bye</strong></div>\n	<div class="column column-8"></div>\n	<div class="column column-9"></div>\n	<div class="column column-10"></div>\n	<div class="column column-11"></div>\n	<div class="column column-12"></div>\n';
 } else { 
__p+='\n	<div class="column column-1 '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		'+
((__t=( round_id ))==null?'':_.escape(__t))+
'\n	</div>\n	<div class="column hidden-mobile '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		'+
((__t=( _.mixinDateFormat(date, "DD/MM") ))==null?'':_.escape(__t))+
'\n	</div>\n	<div class="column column-3 '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		<figure>\n			<picture>\n				<img src="'+
((__t=( squads_logos ))==null?'':_.escape(__t))+
''+
((__t=( opponent_id ))==null?'':_.escape(__t))+
'.png" alt="" />\n			</picture>\n		</figure>\n		<span class="hidden-mobile">\n			'+
((__t=( opponent ))==null?'':_.escape(__t))+
'\n		</span>\n	</div>\n	<div class="column column-4 hidden-mobile '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		('+
((__t=( venue ))==null?'':_.escape(__t))+
')\n	</div>\n	<div class="column column-5 hidden-mobile '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
'" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( opp_games ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-6 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( opp_avg ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-7 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( venue_games ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-8 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' hidden-mobile '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( venue_avg ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-9 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( _.mixinNumberOrDash(proj_score) ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-10 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n		';
 } else { 
__p+='\n			'+
((__t=( _.mixinNumberOrDash(break_even) ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-11 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' hidden-mobile '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( be_pct ))==null?'':_.escape(__t))+
'\n			'+
((__t=( be_pct !== '-' ? '%' : '' ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n	<div class="column column-12 coach-stat-item '+
((__t=( (!has_assistant_coach) ? 'js-coach-locked' : '' ))==null?'':_.escape(__t))+
' hidden-mobile '+
((__t=( score == '' ? '' : 'hidden' ))==null?'':_.escape(__t))+
'">\n		';
 if(!has_assistant_coach) { 
__p+='\n			<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="" />\n		';
 } else { 
__p+='\n			'+
((__t=( _.currencyFormat(proj_price_change, '$', true) ))==null?'':_.escape(__t))+
'\n		';
 } 
__p+='\n	</div>\n';
 } 
__p+='';
}
return __p;
};
